/** biome-ignore-all lint/style/useNamingConvention: External API payloads */
/** biome-ignore-all lint/style/noProcessEnv: Configuration file needs process.env */

const idApiBase = process.env.PIANO_ID_API_BASE_URL || '';
const aid = process.env.PIANO_AID || '';
const apiBase = process.env.PIANO_API_BASE_URL || '';
const apiToken = process.env.PIANO_API_TOKEN || '';
const auth = `aid=${aid}&api_token=${apiToken}`;
const baseUrlEzNewswire = process.env.EZ_NEWSWIRE_API_BASE_URL || '';
const publisherIdEzNewswire = process.env.EZ_NEWSWIRE_PUBLISHER_ID || '';

const recurlyKey = process.env.RECURLY_API_KEY || '';
const encodedAuth = Buffer.from(`${recurlyKey}:`).toString('base64');

export const recurlyHeaders = {
  Accept: 'application/vnd.recurly.v2021-02-25+json',
  'Accept-Language': 'en-US',
  Authorization: `Basic ${encodedAuth}`,
  'Content-Type': 'application/json',
};

export const pianoIdEndpoints = {
  getSocialUrl: '/publisher/login/social',
  getUser: '/publisher/users/get', // Basic user info from Piano ID
  getUserToken: '/publisher/token',
  login: '/publisher/login',
  register: '/publisher/register',
  resetPassword: '/publisher/reset/password',
  setPassword: '/publisher/password',
  socialCodeConfirm: '/publisher/login/social/codeConfirm',
  socialLogin: '/publisher/login/social/code',
};

export const pianoEndpoints = {
  customTermsCreate: '/publisher/conversion/custom/create',
  getFullUser: '/publisher/user/get', // Includes more extensive metadata than the Piano ID /publisher/users/get endpoint
  linkedTerm: '/publisher/linkedTerm/event',
  listSubscriptions: '/publisher/subscription/list',
  listTerms: '/publisher/term/list',
  listUserAccesses: '/publisher/user/access/list',
  revokeUserAccess: '/publisher/user/access/revoke',
  updateUser: '/publisher/user/update',
};

export const ezNewswireEndpoints = {
  getRelease: '/press_releases',
};

export const pianoApi = (endpoint: string, additionalParams = '') => `${apiBase}${endpoint}?${auth}${additionalParams}`;
export const pianoIdApi = (endpoint: string, additionalParams = '') =>
  `${idApiBase}${endpoint}?${auth}${additionalParams}`;
export const ezNewswireApi = (endpoint: string, additionalParams = '') =>
  `${baseUrlEzNewswire}${endpoint}?publisher_id=${publisherIdEzNewswire}${additionalParams}`;
